var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import { LEAKAGE_CAUSE_IMPACTED_ELEMENT_AGE_OPTIONS } from '@shared/constants/waterDamageConstants';
import { InsurerFeatureFlag, insurerHasFeature } from '@shared/featureFlags/insurerFeatureFlags';
const claim = namespace('claim');
const qualification = namespace('qualification');
const settings = namespace('settings');
let LeakageCauseImpactedElementAgeQuestion = class LeakageCauseImpactedElementAgeQuestion extends QuestionComponent {
    get selfCareSettings() {
        return this.setting('selfCareSettings');
    }
    updateClaim(leakageCauseImpactedElementAge) {
        this.updateAndSaveWaterDamageQualification({
            qualificationPayload: {
                leakageCauseImpactedElementAge,
            },
            step: this.step,
        });
    }
    get leakageCauseImpactedElementAgeOptions() {
        return Object.values(LEAKAGE_CAUSE_IMPACTED_ELEMENT_AGE_OPTIONS);
    }
    get panelTitle() {
        return this.$tc('claim.qualification.leakage_cause_impacted_element_age.title');
    }
    get sidebarTitle() {
        const key = 'claim.qualification.leakage_cause_impacted_element_age.sidebar_title';
        return this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get answer() {
        if (!this.waterDamageQualification.leakageCauseImpactedElementAge) {
            return null;
        }
        const option = LEAKAGE_CAUSE_IMPACTED_ELEMENT_AGE_OPTIONS[this.waterDamageQualification.leakageCauseImpactedElementAge];
        return option ? this.$tc(option.answerTradKey, 0) : null;
    }
    get hideHelpLink() {
        return insurerHasFeature(InsurerFeatureFlag.HideHelpLink);
    }
    get showHelpLink() {
        var _a, _b, _c, _d;
        if (this.hideHelpLink &&
            ((_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.pages) === null || _c === void 0 ? void 0 : _c.leakageCauseImpactedElementAge) === null || _d === void 0 ? void 0 : _d.showHelpLink) ===
                false) {
            return false;
        }
        return true;
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], LeakageCauseImpactedElementAgeQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], LeakageCauseImpactedElementAgeQuestion.prototype, "waterDamageQualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], LeakageCauseImpactedElementAgeQuestion.prototype, "updateAndSaveWaterDamageQualification", void 0);
__decorate([
    settings.Getter('setting')
], LeakageCauseImpactedElementAgeQuestion.prototype, "setting", void 0);
LeakageCauseImpactedElementAgeQuestion = __decorate([
    Component({
        components: { RadioPrimaryButton, QuestionPanel },
        props: QuestionProps,
    })
], LeakageCauseImpactedElementAgeQuestion);
export default LeakageCauseImpactedElementAgeQuestion;
